<template>
    <v-main :style="{background: theme.espotoYellow}">
      <v-container class="">
		<EspSnackbar v-model="snackbarShow" light :color="theme.espotoYellow2" :text="snackbarText"/>
        <v-layout text-center>
          <v-flex class="mt-12 pt-12 pa-5 text-center">
			<HLFormPasswordReset v-if="tokenByUrl" @next="onPasswordChanged" :token="tokenByUrl" class="mb-5"/>
			<div v-else>
				<h2>Ungültiger Zugang.</h2>
				<p class="pt-3">Bitte setze dein Passwort erneut zurück.</p>
			</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>

</template>

<script>
import {layoutMixin} from '@/utils/layout-mixin'
import {settingsMixin} from '@/utils/settings-mixin'
import HLFormPasswordReset from '@/components/dashboard/HLFormPasswordReset.vue'
import EspSnackbar from '@/components/ui/EspSnackbar.vue'

export default {
	components:{
		EspSnackbar,
		HLFormPasswordReset
	},
	mixins: [layoutMixin,settingsMixin],
	data(){
		return {
			snackbarShow:false,
			snackbarText:'',
			send_logout_error:false
		}
	},
	computed: {
		tokenByUrl(){
			return (this.$route && this.$route.query)?this.$route.query.token:null;
		},
	},
	methods:{
		onPasswordChanged(){
			/*
			this.snackbarText=this.$t('notification_password_reset_success');
			this.snackbarShow=true;
			*/
			
			this.goToLogin();
		},
	},

	mounted(){
		//Quick fix to redirect user after passwort reset to main page instead of the same password reset page
		if(this.isLoggedIn){
			this.goToHome();
		}
	}

}
</script>

<style scoped>

</style>
